import { Image as DreiImage } from '@react-three/drei';

// The types are broken for the `scale` property of the Image
// component, so we hack around it here
export const Image: any = (props: any) => <DreiImage {...props} />;
